









































import Vue from "vue";
import HttpService from "../services/HttpService";
import { Events, ErrorMessages } from "../utils/Constants";
export default Vue.extend({
  name: "FileUpload",
  data() {
    return {
      dropFiles: [] as Array<File>,
      isLoading: false as boolean,
      submitButtonText: "Submit files" as string,
      loadingButtonText: "Please wait" as string,
      displayButtonText: "Submit files" as string
    };
  },
  props: {
    requiredFiles: {
      type: Array,
      required: true,
      validator: (value: Array<string>) => value.length === 2
    }
  },
  methods: {
    deleteDropFile(index: number): void {
      this.dropFiles.splice(index, 1);
    },
    openErrorSnackbar(message: string): void {
      this.$buefy.snackbar.open({
        message: `${ErrorMessages.REQUEST_FAILED}: ${message}`,
        type: "is-danger",
        position: "is-bottom",
        actionText: "close"
      });
    },
    async submit(): Promise<void> {
      try {
        this.isLoading = true;
        this.displayButtonText = this.loadingButtonText;
        const formData = new FormData();
        formData.append("file", this.dropFiles[1]);
        formData.append("file", this.dropFiles[0]);
        const response = await HttpService.uploadFileRequest(
          "compare-and-match",
          formData
        );
        this.$emit(Events.RESULTS_RECEIVED, response);
      } catch (error) {
        this.openErrorSnackbar(error.message);
      } finally {
        this.displayButtonText = this.submitButtonText;
        this.isLoading = false;
      }
    }
  },
  computed: {
    hasAllRequiredFiles(): boolean {
      return this.dropFiles.length >= 2;
    },
    fileNamesAreValid(): boolean {
      return this.dropFiles.every((e: File) =>
        this.requiredFiles.includes(e.name)
      );
    },
    isSubmitDisabled(): boolean {
      return (
        !this.hasAllRequiredFiles || this.isLoading || !this.fileNamesAreValid
      );
    }
  }
});
